var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDriver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7549 0.514648C6.16488 0.514648 0 6.77082 0 14.4658C0 17.1508 0.211172 18.1395 0.826172 20.6445C0.961172 21.1395 1.31918 21.5313 1.78418 21.6963L22.2451 28.9092C22.4101 28.9692 22.5752 29 22.7402 29C23.1902 29 23.6092 28.8063 23.9092 28.4463L27.627 24.0605C27.999 23.6 27.7095 22.9287 27.123 22.8477C18.879 21.7167 12.8161 16.7892 11.3086 15.4092C9.75309 15.0552 8.65711 13.4516 9.09961 11.7266C9.44461 10.3811 10.7458 9.5 12.1348 9.5H25.4648C26.0123 9.5 26.3905 8.92409 26.1475 8.43359C23.6965 3.48959 18.8864 0.514648 13.7549 0.514648ZM26.5137 12.4854L15 12.5C15 13.115 14.8202 13.6987 14.4902 14.1787C16.7282 15.9322 21.645 19.2035 27.627 20C28.11 20.0645 28.5263 19.6466 28.4648 19.1621C28.3448 18.2171 27.5581 14.5188 27.2461 13.0713C27.1726 12.7248 26.8677 12.4854 26.5137 12.4854Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriver);
export default __webpack_public_path__ + "static/media/driver.8b837be65587192c8dc4e74b07e5778e.svg";
export { ForwardRef as ReactComponent };